import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "src/App";
import ProductionErrorBoundary from "src/components/common/ProductionErrorBoundary";

// Ignore known noisy browser ResizeObserver errors in development overlay.
const resizeObserverErrorMessages = [
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
];

window.addEventListener("error", (event) => {
  if (resizeObserverErrorMessages.includes(event.message)) {
    event.stopImmediatePropagation();
  }
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = String((event as PromiseRejectionEvent)?.reason ?? "");
  if (
    resizeObserverErrorMessages.some((message) => reason.includes(message))
  ) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <ProductionErrorBoundary>
    <App />
  </ProductionErrorBoundary>,
);
